import { useFlag } from '@calendly/feature-check-react';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { isMIFeatureAvailableSelector } from 'features/billing';
import { useGetMeetingIntelligenceUserSettingsQuery, useNotetakerEntitled } from 'features/meeting_intelligence';
import { ExportButton } from './export_button';
import { PersistentFiltersMenu } from './persistent_filters_menu';
const actionsCss = "a1cd1pug";
export const MeetingsPageHeaderActions = forwardRef(({
  scope,
  canExport,
  filterDefaults,
  onboardingTourSettingsRef
}, ref) => {
  const isDefaultPresetToggleEnabled = useFlag('sa_default_preset_toggle', false);
  const {
    data: meetingIntelligenceUserData
  } = useGetMeetingIntelligenceUserSettingsQuery();
  const isMIBillingFeatureAvailable = useSelector(isMIFeatureAvailableSelector);
  const {
    isEntitled: isNotetakerEntitled
  } = useNotetakerEntitled();
  const notetakerEnabled = !!meetingIntelligenceUserData?.miEnabled || !!isMIBillingFeatureAvailable && isNotetakerEntitled;
  if (!isDefaultPresetToggleEnabled) return null;
  return <div ref={ref} className={actionsCss} data-testid="meetings-page-header-actions">
      <PersistentFiltersMenu ref={onboardingTourSettingsRef} notetakerEnabled={notetakerEnabled} iconOnly />
      {canExport && <ExportButton iconOnly text={null} scope={scope} filterDefaults={filterDefaults} />}
    </div>;
});

require("./meetings_page_header_actions.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meetings_page_header_actions.js");